import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private configService: ConfigService, private authService: AuthenticationService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let modifiedRequest = req.clone();

    const urlsToCheck = [
      this.configService.discountApiUrl,
      this.configService.shippingHandlingApiUrl,
      this.configService.apiUrl
    ];
    const shouldIntercept = urlsToCheck.some(url => req.url.includes(url))
    if (shouldIntercept) {
      modifiedRequest = req.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + (this.configService.accessToken || ''),
          'X-Upstream-Env': this.configService.xUpstreamEnv,
          'x-idp': 'sentinel'
        }
      });
    }
    return next.handle(modifiedRequest);
  }
}



